export enum CustomOfferHistoryStates {
    VALID,
    IN_CONTROL,
    TO_CONTROL,
    CREATED,
    ORDERED,
}
